import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import locale from './locale/localeSlice'
import waiter from './waiter'
import masters from './masters'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        locale,
        waiter,
        masters,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
